<template>
	<div class="home_box">
		<div class="top">
			<div class="top_title">您需要什么帮助？</div>
			<div class="top_search">
				<div class="top_search_icon"><img src="/img/helpCenter/icon-sousuo-color.png"></div>
				<a-input class="top_search_input" type="text" v-model:value="searchHistory.value" allowClear placeholder="输入问题关键词" @pressEnter="searchBtn(searchHistory.value)" @click="searchHistory.getFocus" @blur="searchHistory.loseFocus" />
				<div class="top_search_btn" @click="searchBtn(searchHistory.value)">搜索</div>
				<div class="top_search_box" v-if="searchHistory.showBox">
					<div class="title">
						<div class="title_left">
							搜索历史
						</div>
						<div class="title_right">
							<!-- <img src="/img/helpCenter/icon-del.png" @click="searchHistory.delHistory"> -->
							<view class="mbm-iconfont mbm-suosou"></view>
						</div>
					</div>
					<p class="list" v-for="(item,index) in searchHistory.list" :key="index" @click="searchHistory.history(item)">{{item.content}}</p>
				</div>
			</div>
			<div class="top_heat"><span style="color:#09bd71;font-weight: 550;">热搜：</span>
				<div style="cursor: pointer;margin-right:10px;display: inline-block;" v-for="(item,index) in searchHistory.hotList" @click="searchBtn(item.content)" :key="index">{{item.content}}</div>
			</div>
		</div>
		<div class="content" v-if="!searchHistory.bool">
			<div class="content_through">
				<div class="content_through_title_box">
					<div class="left_icon"></div>
					<div class="title">问题直通车</div>
					<div class="title_tabs">
						<div :class="['title_tabs_box',index==through.tbasIndex?'title_tabs_box_color':'']" v-for="(item,index) in through.tabsList" :key="index" @click="through.selectIndex(index)">
							<div style="margin:auto;">{{item.cate_name}}</div>
						</div>
					</div>
				</div>
				<div class="content_list">
					<div class="content_list_box" v-for="(item,index) in through.tabsList[through.tbasIndex]?.pages" :key="index" @click="toHelpList(item)">
						<div class="title">
							<img style="width:22px;height:22px;" src="/img/helpCenter/icon-ask.png">
							<span class="title_text">{{item.page_name}}</span>
							<div class="title_line"></div>
						</div>
						<div class="text">
							{{item.page_describe}}
						</div>
						<div class="see">查看详情</div>
					</div>
				</div>
				<div class="conten_refresh" @click="through.changeThrough">换一批<img src="/img/helpCenter/icon-refresh.png"></div>
			</div>
			<div class="content_modular">
				<div class="content_through_title_box">
					<div class="left_icon"></div>
					<div class="title">问题模块</div>
				</div>
				<div class="content_list">
					<div class="content_list_box"  v-for="(item,index) in problem.list" :key="index" @click="toHelpList(item)">
						<div class="title">
							<div class="title_left">
								<img src="/img/helpCenter/icon-application.png">
								<span class="title_text">{{item.cate_name}}</span>
							</div>
							<div style="float: right;"><RightOutlined /></div>
						</div>
						<div class="title_line"></div>
						<div class="text">
							{{item.describe}}
						</div>
						<div class="see">查看全部</div>
					</div>
				</div>
			</div>
		</div>
		<div class="result" v-else>
			<div class="result_title">
				<div class="result_title_tabs_box">
					<div :class="['result_title_tabs',index==searchResult.tabsIndex? 'result_title_tabs_color':'']" v-for="(item,index) in searchResult.tabs" :key="index" @click="searchResult.tbasSwitch(index)">
						<div class="result_title_tabs_text ">{{item.title}}</div>
					</div>
				</div>
				<div class="result_title_text">微微二维码共为您找到{{page.total}}个搜索结果</div>
			</div>
			<div class="result_content">
				<div class="result_content_load" v-if="searchResult.load"><a-spin /></div>
				<div class="result_content_box" v-for="(item,index) in searchResult.list" :key="index" @click="searchResult.toPage(item)">
					<div class="title">
						<img style="width:20px;height:20px;" src="/img/helpCenter/icon-ask.png">
						<span class="title_text">{{item.title}}</span>
					</div>
					<div class="text">
						{{item.describe}}
					</div>
					<div class="user">
						<span style="color: #505050;">{{item.type_name}}</span>
						<span style="color: #8A8C8F;margin:0 15px;">阅读 {{item.read_num}}</span>
						<span style="color: #8A8C8F;">{{item.updated_at}}</span>
					</div>
				</div>
				<div v-if="searchResult.list.length<1 && searchHistory.valueResult">
					<a-empty image="/img/community/icon-tu.png">
						<template #description>
						    <span v-if="searchHistory.valueResult">抱歉，没有找到“{{searchHistory.valueResult}}”相关的结果</span>
						</template>
					</a-empty>
				</div>
			</div>
		</div>
		<div class="page" v-if="searchHistory.bool">
			<a-pagination hideOnSinglePage v-model:current="page.current" v-model:pageSize='page.size' :total="page.total" @change="search()"/>
		</div>
	</div>
</template>

<script>
import { RightOutlined } from '@ant-design/icons-vue';
import apiAxios from '../../../config/request'
	import config from "/src/config/config.js";
	import {Empty,Modal,message} from 'ant-design-vue';
export default {
	components:{
		RightOutlined
	},
	data(){
		return {
			searchHistory:{ //搜索历史
				valueResult:"",
				value:'', //输入框
				showBox:false, //是否显示搜索历史
				bool:false, //是否是搜索结果页
				list:[ //列表
				],
				hotList:[], //热搜
				getFocus:()=>{ //是否显示历史搜索
					if(this.searchHistory.list.length){
						this.searchHistory.showBox = true
					}
				},
				loseFocus:()=>{ //失去焦点
					let that = this
					setTimeout(()=>{
						that.searchHistory.showBox = false
					},150)
				},
				delHistory:()=>{ //删除历史记录
					apiAxios.post("help/searchHistoryDel",{}).then(res=>{
						this.searchHistory.list = [];
					})
				},
				history:item=>{
					this.searchHistory.value = item.content
					this.search(1)
				}
			},
			through:{ //问题直通车部分
				tbasIndex:0,//选中下标
				tabsList:[], //数据
				cateId:null, //换一批数据
				tabsArr:[ //tbas切换数据
					{
						id:1,
						title:'常见问题'
					},{
						id:2,
						title:'充值问题'
					},{
						id:3,
						title:'账号问题'
					},{
						id:4,
						title:'账号问题'
					}
				],
				selectIndex(index){ //选中下标
					this.tbasIndex = index
				},
				getThrough(){ //获取数据
					apiAxios.post('/help/recommend',{cate_id:this.cateId}).then(res=>{
						if(res.data.code==200){
							this.tabsList = res.data.data
						}
					})
				},
				changeThrough(){ //更换数据
					this.cateId = this.tabsList[this.tbasIndex].cate_id
					this.getThrough()
				},
				
			},
			problem:{ //问题模块部分
				list:[
				],
				getList(){ //获取列表数据
					apiAxios.post('/help/problemModule',{}).then(res=>{
						if(res.data.code==200){
							this.list = res.data.data
						}
					})
				},
			},
			searchResult:{ //搜索结果
				tabsIndex:0, //tabs下标
				list:[], //结果列表
				tabs:[ //tabs数据
					{
						title:'全部'
					},
					{
						title:'帮助中心'
					},
					{
						title:'社区问答'
					},
				],
				tbasSwitch:index =>{ //tabs切换
					this.searchResult.tabsIndex = index
					this.search(1)
				},
				toPage(item){
					if(config.devEnv=='dev'){
						if(item.type==1){
							window.open('/helpCenterList.html?id='+item.s_id);
						}else{
							window.open('/community/detail.html?id='+item.s_id);
						}
					}else{
						if(item.type==1){
							window.open('/helps/'+item.s_id);
						}else{
							window.open('/question/'+item.s_id);
						}
					}
					
				}
			},
			page:{ //分页
				current:1, //当前分页
				total:0, //总条数
				size:10, //一页多少条
			}
		}
	},
	created() {
		if(way==1){
			this.searchHistory.bool=false;
			this.through.getThrough()
			this.problem.getList()
		}else{
			this.searchHistory.bool=true;
			this.searchHistory.value = keywords;
			this.search(1)
		}
		this.getSearchList()
	},
	methods: {
		searchBtn(value){
			if(!value){
				message.warning("请输入关键词");
				return false;
			}
			if(config.devEnv=='dev'){
				this.searchHistory.value = value;
				this.searchHistory.showBox = false;
				this.search(1);
			}else{
				document.location.href = '/helps/search?q='+value;
			}
		},
		search(page){ //搜索结果
			if(!this.searchHistory.value){
				message.warning("请输入关键词");
				return false;
			}
			this.searchHistory.valueResult="";
			this.searchResult.load=true;
			this.searchHistory.bool = true
			apiAxios.post("/help/helpSearch",{
				keyword:this.searchHistory.value,
				size:this.page.size,
				page:page?page:this.page.current,
				type:this.searchResult.tabsIndex,
			}).then(res=>{
				this.searchHistory.valueResult = this.searchHistory.value;
				this.searchResult.list = res.data.data.data
				this.page.total = res.data.data.total
				this.page.current = res.data.data.current_page
				this.searchResult.load=false;
			}).catch(()=>{
				this.searchResult.load=false;
			})
		},
		getSearchList(){ //获取搜索历史列表
			apiAxios.post('/help/searchHistory',{}).then(res=>{
				this.searchHistory.list = res.data.data.data
			})
			apiAxios.post('/help/hotSearch',{}).then(res=>{
				this.searchHistory.hotList = res.data.data
			})
		},
		toHelpList(item){ //跳转到帮助中心列表
			if(config.devEnv=='dev'){
				document.location.href = '/helpCenterList.html';
			}else{
				document.location.href = '/helps/'+item.page_id;
			}
		}
	},
}
</script>

<style scoped lang="less">
.content_through_title_box{
	display: flex;
	align-items: center;
	height: 30px;
	width: 100%;
	background-color: #FFFFFF;
	.left_icon{
		width: 4px;
		height: 18px;
		// background: #285AF9;
		background: #09bd71;
		border-radius: 2px;
		margin-right: 18px;
	}
	.title{
		font-size: 22px;
		color: #000000;
		font-weight: bold;
	}
	.title_tabs{
		margin-left: 247px;
		display: flex;
		.title_tabs_box{
			width: 90px;
			height: 30px;
			background: #E5E8EE;
			border-radius: 15px;
			color: #747474;
			font-size: 14px;
			display: flex;
			margin-right: 24px;
			cursor: pointer;
		}
		.title_tabs_box_color{
			// background: #285AF9;
			background: #09bd71;
			color: #fff;
		}
	}
}
.home_box{
	margin: 0;
	padding: 0;
	.top{
		width: 100%;
		height: 327px;
		// background-color: #F1F6FC;
		background-color: #f3f3f3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.top_title{
			font-size: 34px;
			color: #010101;
			font-weight: bold;
		}
		.top_search{
			width: 620px;
			height: 54px;
			background: #FFFFFF;
			// border: 1px solid #165DFF;
			border: 1px solid #09bd71;
			border-radius: 27px;
			margin-top: 63px;
			margin-bottom: 35px;
			display: flex;
			align-items: center;
			position: relative;
			.top_search_icon{
				width: 50px;
				min-width: 50px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 17px;
					height: auto;
				}
			}
			.top_search_btn{
				// color:#285AF9;
				color:#09bd71;
				font-size:14px;
				cursor: pointer;
				width: 54px;
				min-width: 54px;
				padding-left: 14px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				box-sizing: content-box;
			}
			.top_search_input{
				flex: 1;
				border: 0 !important;
				box-shadow: none !important;
				height: 100%;
				outline: none;
				padding: 0;
				/deep/ .ant-input-clear-icon{font-size: 16px;}
			}
			.top_search_box{
				position: absolute;
				top: 60px;
				width: 620px;
				background: #FFFFFF;
				box-shadow: 0px 2px 4px 0px rgba(207,207,207,0.25);
				border-radius: 14px;
				padding: 21px 0px 23px 0px;
				z-index: 100;
				.title{
					padding: 0px 24px 0px 18px;
					margin-bottom: 9px;
					overflow: hidden;
					.title_left{
						float: left;
						width: 60px;
						font-size: 14px;
						color: #AAAAAA;
					}
					.title_right{
						float: right;
						img{
							width:14px;
							height:14px;
							cursor: pointer;
						}
					}
				}
				.list{
					margin: 0;
					line-height: 40px;
					padding: 0px 24px 0px 18px;
					font-size: 14px;
					cursor: pointer;
					color: #555555;
					&:hover{
						background-color: #f5f5f5;
					}
				}
			}
		}
		.top_heat{
			width: 379px;
			height: 15px;
			font-size: 14px;
			color: #676767;
			text-align: center;
		}
	}
	.content{
		width: 1200px;
		margin: auto;
		padding-top: 47px;
		padding-bottom: 66px;
		.content_through{
			.content_list{
				margin-top: 55px;
				overflow: hidden;
				// display: flex;
				// flex-wrap: wrap;
				// justify-content: space-between;
				.content_list_box{
					float: left;
					margin-right: 24px;
					padding: 21px 24px 0px 21px;
					border: 1px solid #EEEEEE;
					border-radius: 12px;
					width: 384px;
					height: 218px;
					background: #FFFFFF;
					margin-bottom: 52px;
					position: relative;
					&:hover{
						box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.08);
						cursor: pointer;
					}
					.title{
						.title_text{
							font-size: 16px;
							color: #000000;
							font-weight: bold;
							margin-left: 7px;
						}
						.title_line{
							width: 39px;
							height: 1px;
							background: #C0C0C0;
							margin-top: 17px;
							margin-bottom: 18px;
						}
					}
					.text{
						font-size: 12px;
						color: #888888;
						line-height: 22px;
					}
					.see{
						position: absolute;
						bottom: 28px;
						left: 24px;
						font-size: 14px;
						// color: #165DFF;
						color: #09bd71;
						cursor: pointer;
					}
				}
				.content_list_box:nth-child(3n){
					margin-right: 0px;
				}
			}
			.conten_refresh{
				display: flex;
				margin: auto;
				align-items: center;
				width: 63px;
				// color: #285AF9;
				color: #09bd71;
				margin-top: 16px;
				// border-bottom: 1px solid #285AF9;
				border-bottom: 1px solid #09bd71;
				cursor: pointer;
				img{
					margin-left: 7px;
					width:12px;
					height:13px;
				}
			}
		}
		.content_modular{
			padding-top: 80px;
			.content_list{
				margin-top: 55px;
				overflow: hidden;
				// display: flex;
				// flex-wrap: wrap;
				// justify-content: space-between;
				.content_list_box{
					float: left;
					margin-right: 24px;
					padding: 21px 24px 0px 21px;
					border: 1px solid #EEEEEE;
					border-radius: 12px;
					width: 384px;
					height: 218px;
					background: #F4F7FA;
					margin-bottom: 26px;
					position: relative;
					&:hover{
						background: #FFFFFF;
						box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.08);
						cursor: pointer;
					}
					.title{
						overflow: hidden;
						cursor: pointer;
						.title_left{
							float: left;
							display: flex;
							align-items: center;
							img{
								width:22px;
								height:22px;
							}
						}
						.title_text{
							margin-left: 9px;
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
					}
					.title_line{
						width: 100%;
						height: 1px;
						background: #C0C0C0;
						margin-top: 17px;
						margin-bottom: 18px;
					}
					.text{
						font-size: 14px;
						color: #333333;
						line-height: 28px;
					}
					.see{
						position: absolute;
						bottom: 24px;
						right: 24px;
						font-size: 14px;
						// color: #165DFF;
						color: #09bd71;
						cursor: pointer;
					}
				}
				.content_list_box:nth-child(3n){
					margin-right: 0px;
				}
			}
		}
	}
	.result{
		width: 1212px;
		margin: auto;
		.result_title{
			width: 100%;
			padding-top: 33px;
			.result_title_tabs_box{
				margin-bottom: 25px;
				display: flex;
				.result_title_tabs{
					padding: 8px 15px 6px 12px;
					background: #FFF;
					border-radius: 8px;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 1;
					cursor: pointer;
					margin-right: 13px;
					.result_title_tabs_text{
						color: #333;
					}
				}
				.result_title_tabs_color{
					padding: 8px 15px 6px 12px;
					background: #F5F7FF;
					.result_title_tabs_text{
						// color: #285AF9 !important;
						color: #09bd71 !important;
					}
				}
			}
			.result_title_text{
				margin-left: 12px;
				color: #7B7B7B;
				padding-bottom: 4px;
			}
		}
		.result_content{
			margin-left: 12px;
			min-height: 400px;
			position: relative;
			.result_content_load{
				position: absolute;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				text-align: center;
				background-color: rgba(255,255,255,0.85);
				z-index: 1;
				padding-top: 80px;
			}
			.result_content_box{
				cursor: pointer;
				margin-top: 33px;
				border-bottom: 1px solid #e7e7e7;
				.title{
					.title_text{
						margin-left: 9px;
						width: 102px;
						font-size: 16px;
						color: #333333;
					}
				}
				.text{
					margin-left: 29px;
					color: #8A8C8F;
					line-height: 24px;
					margin-top: 21px;
					margin-bottom: 27px;
				}
				.user{
					margin-left: 29px;
					margin-bottom: 31px;
				}
			}
		}
	}
	.page{
		width: 1200px;
		margin: auto;
		display: flex;
		justify-content: center;
		padding: 50px 0;
	}
}
</style>